export default {
    ru: {
        time_to_pay: 'Время на выполнение',
        all_deals: 'Все сделки',
        seller_amount: 'Сумма продажи',
        buyer_amount: 'Сумма покупки',
        seller: 'Продавец',
        buyer: 'Покупaтель',
        bank_code: 'Банк',
        description: 'Описание',
        card_number: 'Номер карты',
        account_number: 'Номер счета',
        phone_number: 'Номер телефона',
        date_created: 'Дата создания',
        undefined: 'Не определен',
        deal_link: 'Ссылка на сделку',
        process: 'Процесс сделки',
        ad: 'Объявление',
        btn_cancel: 'Отменить',
        btn_confirm: 'Подтвердить',
        confirm_send: 'Подтвердить отправку товара',
        confirm_get: 'Подтвердить получение товара',
        cancel: 'Отменить сделку',
        btn_sent: 'Я отправил товар',
        btn_get: 'Я получил товар',

        //steps
        step_1: 'Сделка создана',
        step_2: 'Найден покупатель',
        step_3: 'Оплата сделки произведена',
        step_4: 'Товар отправлен покупателю',
        step_5: 'Товар получен покупателем',
        step_6: 'Сделка завершена',
        
        seller_step_1: 'Отправьте покупателю ссылку на сделку',
        seller_step_2: 'Ожидайте оплаты сделки покупателем',
        seller_step_3: 'Отправьте товар продавцу и подтвердите отправку',
        seller_step_4: 'Ожидайте подтверждения получения товара покупателем',
        seller_step_5: 'Ожидайте выплаты по сделке на ваши реквизиты',
        seller_step_6: 'Сделка завершена. Выплата произведена',

        buyer_step_1: 'Сделка создана. Оплатите сделку продавцу',
        buyer_step_2: 'Оплатите сделку продавцу',
        buyer_step_3: 'Ожидайте отправки товара продавцом',
        buyer_step_4: 'Подтвердите получение товара',
        buyer_step_5: 'Получение товара подтверждено. Оплата скоро зачислится на счет продавца',
        buyer_step_6: 'Сделка завершена. Оплата произведена',
    },

    en: {
        time_to_pay: 'Time to complete',
        all_deals: 'All deals',
        seller_amount: 'Seller amount',
        buyer_amount: 'Buyer amount',
        seller: 'Seller',
        buyer: 'Buyer',
        bank_code: 'Bank',
        description: 'Description',
        card_number: 'Card number',
        account_number: 'Account number',
        phone_number: 'Phone number',
        date_created: 'Date created',
        undefined: 'Undefined',
        deal_link: 'Deal link',
        process: 'Deal process',
        ad: 'Ad',
        btn_cancel: 'Cancel',
        btn_confirm: 'Approve',
        confirm_send: 'Confirm sending the goods',
        confirm_get: 'Confirm receipt of the goods',
        cancel: 'Cancel deal',
        btn_sent: 'I sent the goods',
        btn_get: 'I received the goods',

        //steps
        step_1: 'Deal created',
        step_2: 'Buyer found',
        step_3: 'Deal payment made',
        step_4: 'Goods sent to buyer',
        step_5: 'Goods received by buyer',
        step_6: 'Deal completed',

        seller_step_1: 'Send the buyer a link to the deal',
        seller_step_2: 'Wait for the buyer to pay for the deal',
        seller_step_3: 'Send the goods to the seller and confirm the shipment',
        seller_step_4: 'Wait for the buyer to confirm receipt of the goods',
        seller_step_5: 'Wait for the deal to be paid to your details',
        seller_step_6: 'Deal completed. Payment made',

        buyer_step_1: 'Deal created. Pay the seller for the deal',
        buyer_step_2: 'Pay the seller for the deal',
        buyer_step_3: 'Wait for the seller to send the goods',
        buyer_step_4: 'Confirm receipt of the goods',
        buyer_step_5: 'Goods received. Payment will be credited to the seller\'s account soon',
        buyer_step_6: 'Deal completed. Payment made',
    },
}